/** FAILED exports � user starts a new export from Download pages. */
export const EXPORT_FAILED_LIST_HINT = "Start a new export.";

export const EXPORT_FAILED_DETAIL_HINT =
  "Start a new export from the Download pages to try again.";
